export class ResetarSenhaDto {
    idUsuario: number;
    roleId: number;
    token: string;
    senha: string;
}
